export default "__VITE_ASSET__Ct88caBz__"